export default __webpack_public_path__ + "static/media/v1switch.258e561c.jpg";